module.exports = __webpack_public_path__ + "static/media/iconcoins.db4c9d4a.png";